import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const DollarSign = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00053 1.52644C8.39759 1.52667 8.71982 1.84862 8.71982 2.24573V2.96501L9.00191 2.9785C10.3966 3.11476 11.4866 4.24987 11.5801 5.64996C11.6065 6.04618 11.3064 6.38984 10.9103 6.41645C10.5142 6.44268 10.1716 6.14263 10.1449 5.74662C10.0948 4.99388 9.4751 4.4038 8.71982 4.40358H7.14301C6.42431 4.40365 5.84275 4.98582 5.84268 5.70391C5.84268 6.30044 6.24915 6.82078 6.8272 6.96603L9.52339 7.64261C10.7422 7.94868 11.5958 9.0448 11.5958 10.3006C11.5958 11.8142 10.3688 13.0392 8.85693 13.0395H8.71982V13.7543C8.71982 14.1514 8.39759 14.4733 8.00053 14.4736C7.60328 14.4736 7.28125 14.1515 7.28125 13.7543V13.0395C5.75035 13.0395 4.51674 11.8445 4.41872 10.3489C4.39279 9.95268 4.6924 9.60975 5.08856 9.58355C5.48471 9.55785 5.82787 9.85836 5.85392 10.2545C5.90337 11.0099 6.52323 11.6009 7.28013 11.6009H7.95558C7.97037 11.6 7.98551 11.5964 8.00053 11.5964C8.0157 11.5964 8.03056 11.6 8.04549 11.6009H8.85693C9.57485 11.6006 10.1572 11.0192 10.1573 10.3006C10.1573 9.70378 9.75114 9.18381 9.17274 9.03847L6.47655 8.36189C5.25927 8.05601 4.40411 6.96026 4.40411 5.70391C4.40419 4.19186 5.62927 2.96508 7.14301 2.96501H7.28125V2.24573C7.28125 1.84848 7.60328 1.52644 8.00053 1.52644Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default DollarSign;
